var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSynchronize = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4883 14.5331L20.2977 13.7729L21 16.8134",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2979 13.7729C19.674 15.6863 18.5407 17.357 17.0408 18.5745C15.541 19.7919 13.7417 20.5016 11.8697 20.614C10.1393 20.6144 8.45074 20.0383 7.03336 18.9639C5.61598 17.8896 4.53849 16.3691 3.94727 14.6091",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 10.0809L3.70233 10.8411L2.99998 7.80058",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70208 10.8411C4.32599 8.92766 5.45929 7.25697 6.95915 6.03954C8.45902 4.82211 10.2583 4.11244 12.1303 3.99997C13.8607 3.99964 15.5493 4.57576 16.9666 5.65008C18.384 6.72441 19.4615 8.24487 20.0527 10.0049",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSynchronize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Synchronize.32835e76.svg";
export { ForwardRef as ReactComponent };